import { CSSProperties, ReactElement, Suspense, lazy } from 'react';

const UIAnimationImpl = lazy(() => import('./non-suspense-ui-animation'));

export type UIAnimationProps = {
    animationData: unknown;
    loop?: boolean;
    autoplay?: boolean;
    style?: CSSProperties;
};

export function UIAnimation(props: UIAnimationProps): ReactElement {
    return (
        <Suspense fallback={null}>
            <UIAnimationImpl {...props} />
        </Suspense>
    );
}
